import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import commingSoon from "../../../assets/img/coming soon.jpg";

import { SERVER_PATH } from "../../../config/env";
import { FadeLoader } from "react-spinners";
import apiClient from "../../../utils/api";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#000",
};

const Yoga = () => {
  const [yogaProduct, setYogaProduct] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    apiClient
      // .post(`get/all_products.php`, {
      //   category: "yoga",
      // })
      .post(`get/active_products.php`, {
        category: "gain",
      })
      .then((res) => {
        const woodenCategory = res.data.filter(
          (item) => item.category?.toLowerCase() === "gain"
        );
        setYogaProduct(woodenCategory);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to fetch:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
    window.scrollTo(0, 0);
  }, []);

  if (loading) {
    return (
      <>
        <FadeLoader color="#000" size={250} cssOverride={override} />
        <h2 className="text-center mt-3">Loading...</h2>
      </>
    );
  }

  return (
    <>
      {yogaProduct.length >= 1 ? (
        <>
          {yogaProduct.map((data, index) => {
            return (
              <>
                <div
                  className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 mt-3"
                  key={"product" + index}
                >
                  <div className="card mb-4 product-wap rounded-0 h-100">
                    <div className="card rounded-0 shadow-none">
                      <img
                        className="card-img rounded-0 img-fluid"
                        src={data.img1}
                        alt={data.product_name}
                      />
                      <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                        <ul className="list-unstyled">
                          <li>
                            <Link
                              className="btn btn-success text-white mt-2"
                              to={`/product/${data.product_id}`}
                            >
                              <AiOutlineEye
                                style={{ fontSize: "1.3em", marginTop: "-3px" }}
                              />
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body d-flex flex-column text-center">
                      <Link
                        to="/"
                        className="text-decoration-none products-title"
                      >
                        {data.product_name}{" "}
                        <small className="ms-1">{data.weight}Gms.</small>
                      </Link>
                      <span className="d-block text-secondary my-2">
                        RS.
                        {parseInt(
                          (data.offer_price =
                            data.price - (data.price * data.offer) / 100)
                        )}
                      </span>
                      <Link to={`/product/${data.product_id}`}>
                        <button className="btn btn-sm w-100 btn-outline-success text-uppercase price-btn">
                          Buy Now
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </>
      ) : (
        <>
          <div className="col-md-3">
            <div className="card mb-4 product-wap rounded-1">
              <div className="card rounded-0">
                <img
                  className="card-img rounded-0 img-fluid"
                  style={{ height: "180px", objectFit: "cover" }}
                  src={commingSoon}
                  alt="coming soon..."
                />
                <div className="card-img-overlay rounded-0 product-overlay d-flex align-items-center justify-content-center">
                  <ul className="list-unstyled">
                    <li>
                      <AiOutlineEye
                        style={{ fontSize: "1.3em", marginTop: "-3px" }}
                      />
                    </li>
                  </ul>
                </div>
              </div>
              <div className="card-body">
                <Link to="/" className="h3 text-decoration-none">
                  Coming soon...
                </Link>
              </div>
            </div>
          </div>
          {/* <FadeLoader color="#000" size={250} cssOverride={override} />
          <h2 className="text-center mt-3">Loading...</h2> */}
        </>
      )}
    </>
  );
};
export default Yoga;
